import { gradientModelManager } from './gradient-model-manager';
import { convertHSLColorToCssString } from './convert-hsl-color-to-css-string';

function buildGradientStopsParts(colorStops) {
  const sortedStops = [...colorStops].sort(
    (a, b) =>
      gradientModelManager.extractStopPosition(a) - gradientModelManager.extractStopPosition(b)
  );

  return sortedStops.map(
    (stop) => `${convertHSLColorToCssString(stop.value)} ${stop.length.value}%`
  );
}

export function buildLinearGradientCssString(angle, colorStops) {
  const parts = buildGradientStopsParts(colorStops);

  return `linear-gradient(${angle}deg, ${parts.join(', ')})`;
}

export function buildRadialGradientCssString(position, endingShape, colorStops) {
  const parts = buildGradientStopsParts(colorStops);

  return `radial-gradient(${endingShape} at ${position.x}% ${position.y}%, ${parts.join(', ')})`;
}
